// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   USER ACCOUNT COMPONENT STYLES
   ========================================================================== */

/* CSS Custom Properties */
:root {
  --user-account-transition: 0.2s ease;
  --user-account-border-radius: 4px;
  --user-account-border-radius-full: 50%;
  --user-account-avatar-size: 20px;
  --user-account-spacing-xs: 0.25rem;
  --user-account-spacing-sm: 0.5rem;
  --user-account-spacing-md: 0.75rem;
  --user-account-spacing-lg: 1rem;
  --user-account-spacing-xl: 1.5rem;
}

/* ==========================================================================
   DRAGGABLE MODAL BASE STYLES
   ========================================================================== */

.draggable-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
  max-height: 100vh;
}

.draggable-box {
  background-color: var(--color-dark-background);
  width: 300px;
  max-width: 90vw;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
  position: relative;
  border-radius: var(--user-account-border-radius);
}

.draggable-box__title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--color-dark-border);
  margin: 0;
  height: 25px;
  width: 100%;
  border-radius: var(--user-account-border-radius) var(--user-account-border-radius) 0 0;
}

.draggable-box__title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 0.9rem;
  font-weight: 500;
}

.draggable-box__title h3 {
  margin: 0;
  user-select: none;
}

.draggable-box__content {
  border: 5px solid var(--color-dark-border);
  border-top: 0;
  border-radius: 0 0 var(--user-account-border-radius) var(--user-account-border-radius);
}

.draggable-box__btn {
  position: absolute;
  width: 0.9em;
  height: 0.9em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: var(--color-dark-border);
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
  transition: all var(--user-account-transition);
  border: none;
}

.draggable-box__dock-btn {
  right: 3em;
  background: var(--colorCautionDarken1);
}

.draggable-box__dock-btn:hover {
  background: var(--colorCautionDarken2);
}

.draggable-box__close-btn {
  right: 1em;
  background: var(--color-dark-text-accent);
}

.draggable-box__close-btn:hover {
  background: var(--color-primary);
}

/* ==========================================================================
   CONFIRM MODAL
   ========================================================================== */

.confirm-modal {
  display: flex;
  flex-direction: column;
  gap: var(--user-account-spacing-xl);
  padding: var(--user-account-spacing-xl);
  min-width: 320px;
}

.confirm-modal__content {
  text-align: center;
}

.confirm-modal__message {
  margin: 0;
  color: var(--color-dark-text);
  font-size: 1rem;
  line-height: 1.5;
}

.confirm-modal__actions {
  display: flex;
  justify-content: center;
  gap: var(--user-account-spacing-lg);
  flex-wrap: wrap;
}

.confirm-modal__btn {
  min-width: 100px;
  padding: var(--user-account-spacing-md) var(--user-account-spacing-xl);
  border: none;
  border-radius: var(--user-account-border-radius);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--user-account-transition);
  text-align: center;
}

.confirm-modal__btn:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.confirm-modal__btn--primary {
  background-color: var(--color-primary);
  color: #ffffff;
}

.confirm-modal__btn--primary:hover {
  background-color: var(--color-primary-dark);
  transform: translateY(-1px);
}

.confirm-modal__btn--destructive {
  background-color: var(--color-primary);
  color: #ffffff;
}

.confirm-modal__btn--destructive:hover {
  background-color: var(--color-primary-dark);
  transform: translateY(-1px);
}

.confirm-modal__btn--secondary {
  background-color: transparent;
  color: var(--color-primary-dark);
  border: 1px solid var(--color-dark-border);
}

.confirm-modal__btn--secondary:hover {
  background-color: var(--color-dark-border);
  color: var(--color-dark-text);
  transform: translateY(-1px);
}

/* ==========================================================================
   INPUT MODAL
   ========================================================================== */

.input-modal {
  display: flex;
  flex-direction: column;
  gap: var(--user-account-spacing-xl);
  padding: var(--user-account-spacing-xl);
  min-width: 320px;
}

.input-modal__content {
  display: flex;
  flex-direction: column;
  gap: var(--user-account-spacing-sm);
}

.input-modal__label {
  color: var(--color-dark-text-accent);
  font-size: 0.9rem;
}

.input-modal__input {
  width: 100%;
  padding: var(--user-account-spacing-md);
  background: var(--color-dark-border);
  border: 1px solid var(--color-dark-text-accent);
  border-radius: var(--user-account-border-radius);
  color: var(--color-dark-text);
  font-size: 1rem;
  box-sizing: border-box;
}

.input-modal__input:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: -1px;
}

/* ==========================================================================
   LIST SELECTOR MODAL
   ========================================================================== */

.list-selector-modal {
  display: flex;
  flex-direction: column;
  gap: var(--user-account-spacing-lg);
  padding: var(--user-account-spacing-xl);
  min-width: 280px;
  max-height: 400px;
}

.list-selector-modal__list {
  display: flex;
  flex-direction: column;
  gap: var(--user-account-spacing-sm);
  overflow-y: auto;
  max-height: 300px;
}

.list-selector-modal__item {
  display: flex;
  align-items: center;
  gap: var(--user-account-spacing-md);
  padding: var(--user-account-spacing-sm) var(--user-account-spacing-md);
  border-radius: var(--user-account-border-radius);
  cursor: pointer;
}

.list-selector-modal__item:hover {
  background: var(--color-dark-border);
}

.list-selector-modal__checkbox {
  width: 16px;
  height: 16px;
  accent-color: var(--color-primary);
  cursor: pointer;
  -webkit-appearance: auto !important;
  appearance: auto !important;
  opacity: 1 !important;
  position: static !important;
  pointer-events: auto !important;
}

.list-selector-modal__checkbox+.list-selector-modal__name::before,
.list-selector-modal__checkbox+.list-selector-modal__name::after {
  display: none !important;
}

.list-selector-modal__name {
  color: var(--color-dark-text-accent);
  font-size: 0.95rem;
  user-select: none;
}

/* ==========================================================================
   RESPONSIVE DESIGN
   ========================================================================== */

@media (max-width: 768px) {
  .draggable-box {
    width: 95vw;
    max-width: 95vw;
  }
}

/* ==========================================================================
   LEGACY SUPPORT & ID-BASED SELECTORS
   ========================================================================== */

/* Support both original IDs and new BEM classes for smooth migration */
#top-menu-user-account-li,
.user-account__menu-item {
  display: flex;
  align-items: center;
}

#top-menu-user-account-btn,
#top-menu-user-account-icon,
.user-account__login-btn,
.user-account__profile-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--user-account-avatar-size);
  height: var(--user-account-avatar-size);
  border-radius: var(--user-account-border-radius-full);
  cursor: pointer;
  font-weight: 900;
  font-size: 0.9rem;
  color: var(--color-dark-background);
  transition: filter var(--user-account-transition);
}

#top-menu-user-account-icon.user-account__profile-btn--hidden,
.user-account__profile-btn--hidden {
  display: none;
}

#top-menu-user-account-btn:hover,
#top-menu-user-account-icon:hover,
.user-account__btn--hover:hover {
  filter: brightness(1.2);
}`, "",{"version":3,"sources":["webpack://./src/engine/ui/engine-ui.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,iCAAiC;EACjC,sCAAsC;EACtC,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;EAClC,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sFAAsF;AACxF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,sFAAsF;AACxF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,yCAAyC;EACzC,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sEAAsE;EACtE,YAAY;EACZ,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,oCAAoC;EACpC,+CAA+C;EAC/C,gDAAgD;EAChD,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,sEAAsE;EACtE,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,mCAAmC;EACnC,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;;+EAE+E;;AAE/E,uEAAuE;AACvE;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,uCAAuC;EACvC,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,uBAAuB;AACzB","sourcesContent":["/* ==========================================================================\n   USER ACCOUNT COMPONENT STYLES\n   ========================================================================== */\n\n/* CSS Custom Properties */\n:root {\n  --user-account-transition: 0.2s ease;\n  --user-account-border-radius: 4px;\n  --user-account-border-radius-full: 50%;\n  --user-account-avatar-size: 20px;\n  --user-account-spacing-xs: 0.25rem;\n  --user-account-spacing-sm: 0.5rem;\n  --user-account-spacing-md: 0.75rem;\n  --user-account-spacing-lg: 1rem;\n  --user-account-spacing-xl: 1.5rem;\n}\n\n/* ==========================================================================\n   DRAGGABLE MODAL BASE STYLES\n   ========================================================================== */\n\n.draggable-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.7);\n  max-height: 100vh;\n}\n\n.draggable-box {\n  background-color: var(--color-dark-background);\n  width: 300px;\n  max-width: 90vw;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);\n  position: relative;\n  border-radius: var(--user-account-border-radius);\n}\n\n.draggable-box__title-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--color-dark-border);\n  margin: 0;\n  height: 25px;\n  width: 100%;\n  border-radius: var(--user-account-border-radius) var(--user-account-border-radius) 0 0;\n}\n\n.draggable-box__title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.draggable-box__title h3 {\n  margin: 0;\n  user-select: none;\n}\n\n.draggable-box__content {\n  border: 5px solid var(--color-dark-border);\n  border-top: 0;\n  border-radius: 0 0 var(--user-account-border-radius) var(--user-account-border-radius);\n}\n\n.draggable-box__btn {\n  position: absolute;\n  width: 0.9em;\n  height: 0.9em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background: var(--color-dark-border);\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);\n  transition: all var(--user-account-transition);\n  border: none;\n}\n\n.draggable-box__dock-btn {\n  right: 3em;\n  background: var(--colorCautionDarken1);\n}\n\n.draggable-box__dock-btn:hover {\n  background: var(--colorCautionDarken2);\n}\n\n.draggable-box__close-btn {\n  right: 1em;\n  background: var(--color-dark-text-accent);\n}\n\n.draggable-box__close-btn:hover {\n  background: var(--color-primary);\n}\n\n/* ==========================================================================\n   CONFIRM MODAL\n   ========================================================================== */\n\n.confirm-modal {\n  display: flex;\n  flex-direction: column;\n  gap: var(--user-account-spacing-xl);\n  padding: var(--user-account-spacing-xl);\n  min-width: 320px;\n}\n\n.confirm-modal__content {\n  text-align: center;\n}\n\n.confirm-modal__message {\n  margin: 0;\n  color: var(--color-dark-text);\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.confirm-modal__actions {\n  display: flex;\n  justify-content: center;\n  gap: var(--user-account-spacing-lg);\n  flex-wrap: wrap;\n}\n\n.confirm-modal__btn {\n  min-width: 100px;\n  padding: var(--user-account-spacing-md) var(--user-account-spacing-xl);\n  border: none;\n  border-radius: var(--user-account-border-radius);\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--user-account-transition);\n  text-align: center;\n}\n\n.confirm-modal__btn:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n.confirm-modal__btn--primary {\n  background-color: var(--color-primary);\n  color: #ffffff;\n}\n\n.confirm-modal__btn--primary:hover {\n  background-color: var(--color-primary-dark);\n  transform: translateY(-1px);\n}\n\n.confirm-modal__btn--destructive {\n  background-color: var(--color-primary);\n  color: #ffffff;\n}\n\n.confirm-modal__btn--destructive:hover {\n  background-color: var(--color-primary-dark);\n  transform: translateY(-1px);\n}\n\n.confirm-modal__btn--secondary {\n  background-color: transparent;\n  color: var(--color-primary-dark);\n  border: 1px solid var(--color-dark-border);\n}\n\n.confirm-modal__btn--secondary:hover {\n  background-color: var(--color-dark-border);\n  color: var(--color-dark-text);\n  transform: translateY(-1px);\n}\n\n/* ==========================================================================\n   INPUT MODAL\n   ========================================================================== */\n\n.input-modal {\n  display: flex;\n  flex-direction: column;\n  gap: var(--user-account-spacing-xl);\n  padding: var(--user-account-spacing-xl);\n  min-width: 320px;\n}\n\n.input-modal__content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--user-account-spacing-sm);\n}\n\n.input-modal__label {\n  color: var(--color-dark-text-accent);\n  font-size: 0.9rem;\n}\n\n.input-modal__input {\n  width: 100%;\n  padding: var(--user-account-spacing-md);\n  background: var(--color-dark-border);\n  border: 1px solid var(--color-dark-text-accent);\n  border-radius: var(--user-account-border-radius);\n  color: var(--color-dark-text);\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n.input-modal__input:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: -1px;\n}\n\n/* ==========================================================================\n   LIST SELECTOR MODAL\n   ========================================================================== */\n\n.list-selector-modal {\n  display: flex;\n  flex-direction: column;\n  gap: var(--user-account-spacing-lg);\n  padding: var(--user-account-spacing-xl);\n  min-width: 280px;\n  max-height: 400px;\n}\n\n.list-selector-modal__list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--user-account-spacing-sm);\n  overflow-y: auto;\n  max-height: 300px;\n}\n\n.list-selector-modal__item {\n  display: flex;\n  align-items: center;\n  gap: var(--user-account-spacing-md);\n  padding: var(--user-account-spacing-sm) var(--user-account-spacing-md);\n  border-radius: var(--user-account-border-radius);\n  cursor: pointer;\n}\n\n.list-selector-modal__item:hover {\n  background: var(--color-dark-border);\n}\n\n.list-selector-modal__checkbox {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--color-primary);\n  cursor: pointer;\n  -webkit-appearance: auto !important;\n  appearance: auto !important;\n  opacity: 1 !important;\n  position: static !important;\n  pointer-events: auto !important;\n}\n\n.list-selector-modal__checkbox+.list-selector-modal__name::before,\n.list-selector-modal__checkbox+.list-selector-modal__name::after {\n  display: none !important;\n}\n\n.list-selector-modal__name {\n  color: var(--color-dark-text-accent);\n  font-size: 0.95rem;\n  user-select: none;\n}\n\n/* ==========================================================================\n   RESPONSIVE DESIGN\n   ========================================================================== */\n\n@media (max-width: 768px) {\n  .draggable-box {\n    width: 95vw;\n    max-width: 95vw;\n  }\n}\n\n/* ==========================================================================\n   LEGACY SUPPORT & ID-BASED SELECTORS\n   ========================================================================== */\n\n/* Support both original IDs and new BEM classes for smooth migration */\n#top-menu-user-account-li,\n.user-account__menu-item {\n  display: flex;\n  align-items: center;\n}\n\n#top-menu-user-account-btn,\n#top-menu-user-account-icon,\n.user-account__login-btn,\n.user-account__profile-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--user-account-avatar-size);\n  height: var(--user-account-avatar-size);\n  border-radius: var(--user-account-border-radius-full);\n  cursor: pointer;\n  font-weight: 900;\n  font-size: 0.9rem;\n  color: var(--color-dark-background);\n  transition: filter var(--user-account-transition);\n}\n\n#top-menu-user-account-icon.user-account__profile-btn--hidden,\n.user-account__profile-btn--hidden {\n  display: none;\n}\n\n#top-menu-user-account-btn:hover,\n#top-menu-user-account-icon:hover,\n.user-account__btn--hover:hover {\n  filter: brightness(1.2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
